import { useEffect } from 'react'
import useConfigureAndSendTag from './useConfigureAndSendTag'

const useImpressionTag = (condition, { type, tagInfo }) => {
  const configureAndSendTag = useConfigureAndSendTag()

  useEffect(() => {
    if (condition) {
      configureAndSendTag({
        type,
        tagInfo,
        isImpression: true
      })
    }
  }, [condition])
}

export default useImpressionTag
